import { createSlice } from '@reduxjs/toolkit';
import GetPaginationQueryString from '../../utils/pageExtensions';
import Config from '../../config.js';
import GetHttpResponseError from '../../utils/httpExtensions';

export const organizationSlice = createSlice({
    name: 'organization',
    initialState: {
        organizations: []
    },
    reducers: {
        fetchOrganization: (state, action) => {
            fetch(Config.FHIRAPIUrl + 'Organization/' + action.payload.id)
                .then((response) => response.json())
                .then((response) => {
                    if (action.payload.callback)
                        action.payload.callback(response);
                })
                .catch((error) => {
                    if (action.payload.catch)
                        action.payload.catch(error);
                });
        },
        fetchOrganizations: (state, action) => {
            let paginationQuery = GetPaginationQueryString(action.payload.pagination);

            let url = Config.FHIRAPIUrl + 'Organization?' + paginationQuery;

            if (action.payload.practitionerId)
                url += '&practitionerId=' + action.payload.practitionerId;
            else
                url += '&active=' + action.payload.filter.active
                    + '&name=' + action.payload.filter.name
                    + '&address=' + action.payload.filter.address
                    + '&address-postalcode=' + action.payload.filter['address_postalcode'];

            fetch(url, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${action.payload.token}`
                }
            })
                .then((response) => {
                    GetHttpResponseError(response);
                    
                    return response.json();
                })
                .then((response) => {
                    if (action.payload.callback)
                        action.payload.callback(response);
                })
                .catch((error) => {
                    if (action.payload.catch)
                        action.payload.catch(error);
                });
        },
        setOrganizations: (state, action) => {
            state.organizations = action.payload || [];
        }
    }
})

export const { setOrganizations, fetchOrganization, fetchOrganizations } = organizationSlice.actions

export default organizationSlice.reducer